/**
 * Regras da textura no navegador (2026-10-15) — a mesma régua do backend
 * (`estoque/services_textura.py`), aplicada antes de subir 10 MB para
 * receber um 400. Quem decide de verdade é o backend.
 */
export const TAMANHO_MAX_TEXTURA = 10 * 1024 * 1024;
export const EXTENSOES_TEXTURA = ".jpg,.jpeg,.png,.webp";
const TIPOS_TEXTURA = new Set(["image/jpeg", "image/png", "image/webp"]);

/** Mensagem do problema, ou null se o arquivo serve. */
export function erroDoArquivoDeTextura(arquivo) {
  if (!arquivo) return "Escolha uma imagem.";
  if (!TIPOS_TEXTURA.has(arquivo.type)) return "Envie uma imagem JPG, PNG ou WEBP.";
  if (arquivo.size > TAMANHO_MAX_TEXTURA) return "Imagem maior que 10 MB.";
  return null;
}

/** O tipo do material recebe textura? O mesmo critério da amostra de cor. */
export function tipoAceitaTextura(tipo) {
  return Boolean(tipo?.campos?.some((c) => c.tipo === "cor"));
}

/** O que fazer com a textura depois de salvar o material. */
export function acaoDaTextura(editando) {
  if (editando?.textura_arquivo) return "enviar";
  if (editando?.textura_remover) return "remover";
  return null;
}
